import Vue from 'vue'
import axios from 'axios'
import { merge } from 'lodash'

/**
 * The Store Pattern
 * actions -> mutations
 * Never mutate the store directly.
 */

// initial state
// state.geoStates
// HATCH-460: Once endpoint is working correctly, return initial stateList to empty list []
const state = {
  stateList: [
    {
      country: 'US',
      state: 'AL',
      contiguousState: null,
      id: '13',
      stateName: 'ALABAMA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/13',
    },
    {
      country: 'US',
      state: 'AK',
      contiguousState: null,
      id: '2',
      stateName: 'ALASKA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/2',
    },
    {
      country: 'US',
      state: 'AZ',
      contiguousState: null,
      id: '23',
      stateName: 'ARIZONA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/23',
    },
    {
      country: 'US',
      state: 'AR',
      contiguousState: null,
      id: '19',
      stateName: 'ARKANSAS',
      'item-id': '/sfc/repository/IntegrationRepository/state1/19',
    },
    {
      country: 'US',
      state: 'AA',
      contiguousState: null,
      id: '1',
      stateName: 'Armed Forces Americas',
      'item-id': '/sfc/repository/IntegrationRepository/state1/1',
    },
    {
      country: 'US',
      state: 'AE',
      contiguousState: null,
      id: '6',
      stateName: 'Armed Forces Others',
      'item-id': '/sfc/repository/IntegrationRepository/state1/6',
    },
    {
      country: 'US',
      state: 'AP',
      contiguousState: null,
      id: '17',
      stateName: 'Armed Forces Pacific',
      'item-id': '/sfc/repository/IntegrationRepository/state1/17',
    },
    {
      country: 'US',
      state: 'CA',
      contiguousState: null,
      id: '45',
      stateName: 'CALIFORNIA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/45',
    },
    {
      country: 'US',
      state: 'CO',
      contiguousState: null,
      id: '60',
      stateName: 'COLORADO',
      'item-id': '/sfc/repository/IntegrationRepository/state1/60',
    },
    {
      country: 'US',
      state: 'CT',
      contiguousState: null,
      id: '64',
      stateName: 'CONNECTICUT',
      'item-id': '/sfc/repository/IntegrationRepository/state1/64',
    },
    {
      country: 'US',
      state: 'DE',
      contiguousState: null,
      id: '71',
      stateName: 'DELAWARE',
      'item-id': '/sfc/repository/IntegrationRepository/state1/71',
    },
    {
      country: 'US',
      state: 'DC',
      contiguousState: null,
      id: '69',
      stateName: 'DISTRICT OF COLUMBIA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/69',
    },
    {
      country: 'US',
      state: 'FL',
      contiguousState: null,
      id: '88',
      stateName: 'FLORIDA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/88',
    },
    {
      country: 'US',
      state: 'GA',
      contiguousState: null,
      id: '93',
      stateName: 'GEORGIA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/93',
    },
    {
      country: 'US',
      state: 'HI',
      contiguousState: null,
      id: '15',
      stateName: 'HAWAII',
      'item-id': '/sfc/repository/IntegrationRepository/state1/15',
    },
    {
      country: 'US',
      state: 'ID',
      contiguousState: null,
      id: '122',
      stateName: 'IDAHO',
      'item-id': '/sfc/repository/IntegrationRepository/state1/122',
    },
    {
      country: 'US',
      state: 'IL',
      contiguousState: null,
      id: '124',
      stateName: 'ILLINOIS',
      'item-id': '/sfc/repository/IntegrationRepository/state1/124',
    },
    {
      country: 'US',
      state: 'IN',
      contiguousState: null,
      id: '126',
      stateName: 'INDIANA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/126',
    },
    {
      country: 'US',
      state: 'IA',
      contiguousState: null,
      id: '120',
      stateName: 'IOWA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/120',
    },
    {
      country: 'US',
      state: 'KS',
      contiguousState: null,
      id: '147',
      stateName: 'KANSAS',
      'item-id': '/sfc/repository/IntegrationRepository/state1/147',
    },
    {
      country: 'US',
      state: 'KY',
      contiguousState: null,
      id: '150',
      stateName: 'KENTUCKY',
      'item-id': '/sfc/repository/IntegrationRepository/state1/150',
    },
    {
      country: 'US',
      state: 'LA',
      contiguousState: null,
      id: '153',
      stateName: 'LOUISIANA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/153',
    },
    {
      country: 'US',
      state: 'ME',
      contiguousState: null,
      id: '169',
      stateName: 'MAINE',
      'item-id': '/sfc/repository/IntegrationRepository/state1/169',
    },
    {
      country: 'US',
      state: 'MD',
      contiguousState: null,
      id: '168',
      stateName: 'MARYLAND',
      'item-id': '/sfc/repository/IntegrationRepository/state1/168',
    },
    {
      country: 'US',
      state: 'MA',
      contiguousState: null,
      id: '165',
      stateName: 'MASSACHUSETTS',
      'item-id': '/sfc/repository/IntegrationRepository/state1/165',
    },
    {
      country: 'US',
      state: 'MI',
      contiguousState: null,
      id: '174',
      stateName: 'MICHIGAN',
      'item-id': '/sfc/repository/IntegrationRepository/state1/174',
    },
    {
      country: 'US',
      state: 'MN',
      contiguousState: null,
      id: '180',
      stateName: 'MINNESOTA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/180',
    },
    {
      country: 'US',
      state: 'MS',
      contiguousState: null,
      id: '187',
      stateName: 'MISSISSIPPI',
      'item-id': '/sfc/repository/IntegrationRepository/state1/187',
    },
    {
      country: 'US',
      state: 'MO',
      contiguousState: null,
      id: '182',
      stateName: 'MISSOURI',
      'item-id': '/sfc/repository/IntegrationRepository/state1/182',
    },
    {
      country: 'US',
      state: 'MT',
      contiguousState: null,
      id: '189',
      stateName: 'MONTANA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/189',
    },
    {
      country: 'US',
      state: 'NE',
      contiguousState: null,
      id: '202',
      stateName: 'NEBRASKA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/202',
    },
    {
      country: 'US',
      state: 'NV',
      contiguousState: null,
      id: '219',
      stateName: 'NEVADA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/219',
    },
    {
      country: 'US',
      state: 'NH',
      contiguousState: null,
      id: '205',
      stateName: 'NEW HAMPSHIRE',
      'item-id': '/sfc/repository/IntegrationRepository/state1/205',
    },
    {
      country: 'US',
      state: 'NJ',
      contiguousState: null,
      id: '207',
      stateName: 'NEW JERSEY',
      'item-id': '/sfc/repository/IntegrationRepository/state1/207',
    },
    {
      country: 'US',
      state: 'NM',
      contiguousState: null,
      id: '210',
      stateName: 'NEW MEXICO',
      'item-id': '/sfc/repository/IntegrationRepository/state1/210',
    },
    {
      country: 'US',
      state: 'NY',
      contiguousState: null,
      id: '220',
      stateName: 'NEW YORK',
      'item-id': '/sfc/repository/IntegrationRepository/state1/220',
    },
    {
      country: 'US',
      state: 'NC',
      contiguousState: null,
      id: '199',
      stateName: 'NORTH CAROLINA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/199',
    },
    {
      country: 'US',
      state: 'ND',
      contiguousState: null,
      id: '200',
      stateName: 'NORTH DAKOTA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/200',
    },
    {
      country: 'US',
      state: 'OH',
      contiguousState: null,
      id: '223',
      stateName: 'OHIO',
      'item-id': '/sfc/repository/IntegrationRepository/state1/223',
    },
    {
      country: 'US',
      state: 'OK',
      contiguousState: null,
      id: '224',
      stateName: 'OKLAHOMA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/224',
    },
    {
      country: 'US',
      state: 'OR',
      contiguousState: null,
      id: '227',
      stateName: 'OREGON',
      'item-id': '/sfc/repository/IntegrationRepository/state1/227',
    },
    {
      country: 'US',
      state: 'PA',
      contiguousState: null,
      id: '229',
      stateName: 'PENNSYLVANIA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/229',
    },
    {
      country: 'US',
      state: 'RI',
      contiguousState: null,
      id: '249',
      stateName: 'RHODE ISLAND',
      'item-id': '/sfc/repository/IntegrationRepository/state1/249',
    },
    {
      country: 'US',
      state: 'SC',
      contiguousState: null,
      id: '257',
      stateName: 'SOUTH CAROLINA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/257',
    },
    {
      country: 'US',
      state: 'SD',
      contiguousState: null,
      id: '259',
      stateName: 'SOUTH DAKOTA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/259',
    },
    {
      country: 'US',
      state: 'TN',
      contiguousState: null,
      id: '289',
      stateName: 'TENNESSEE',
      'item-id': '/sfc/repository/IntegrationRepository/state1/289',
    },
    {
      country: 'US',
      state: 'TX',
      contiguousState: null,
      id: '295',
      stateName: 'TEXAS',
      'item-id': '/sfc/repository/IntegrationRepository/state1/295',
    },
    {
      country: 'US',
      state: 'UT',
      contiguousState: null,
      id: '299',
      stateName: 'UTAH',
      'item-id': '/sfc/repository/IntegrationRepository/state1/299',
    },
    {
      country: 'US',
      state: 'VT',
      contiguousState: null,
      id: '310',
      stateName: 'VERMONT',
      'item-id': '/sfc/repository/IntegrationRepository/state1/310',
    },
    {
      country: 'US',
      state: 'VA',
      contiguousState: null,
      id: '302',
      stateName: 'VIRGINIA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/302',
    },
    {
      country: 'US',
      state: 'WA',
      contiguousState: null,
      id: '312',
      stateName: 'WASHINGTON',
      'item-id': '/sfc/repository/IntegrationRepository/state1/312',
    },
    {
      country: 'US',
      state: 'WV',
      contiguousState: null,
      id: '316',
      stateName: 'WEST VIRGINIA',
      'item-id': '/sfc/repository/IntegrationRepository/state1/316',
    },
    {
      country: 'US',
      state: 'WI',
      contiguousState: null,
      id: '314',
      stateName: 'WISCONSIN',
      'item-id': '/sfc/repository/IntegrationRepository/state1/314',
    },
    {
      country: 'US',
      state: 'WY',
      contiguousState: null,
      id: '317',
      stateName: 'WYOMING',
      'item-id': '/sfc/repository/IntegrationRepository/state1/317',
    }
  ]
}


// getters
const getters = {
  stateCodes: (state) => state.stateList.map(stateItem => stateItem.state).sort()
}

// actions - can be async
const actions = {
  /** load a list of US states */
  LOAD_STATES ({ state }) {
    // States don't change often, so we don't need to refetch them if we already have them
    if (!state.stateList.length) {

      this.commit('errors/CLEAR_ERRORS')

      axios.get('/rest/model/atg/commerce/ShippingActor/getStateCodes')
        .then(
          ({ data }) => {
            this.commit('geoStates/SET_STATE_LIST', data.stateList)
          }
        )
        .catch((error) => {
          error.type = 'loadStates'
          this.dispatch('errors/HANDLE_ERROR', error)
        })
    }
  },
}

// mutations - Must be synchronous
const mutations = {
  /**
   * cache a list of states
   * @param {array} states - list of astates
   */
  SET_STATE_LIST (state, stateList) {
    state.stateList = stateList;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
